import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { isPracticeProfile } from '../lib/practiceAccount';

export const PRACTICE_BANNER_TEXT = 'Practice account: everyone here is made up, and nothing you do here reaches real people.';

/**
 * A thin strip along the bottom of every page while signed in to a practice company (a demo-flagged
 * company a prospect clicks through on their own; profiles.isPracticeAccount, set by
 * scripts/demo-trident-practice). Nothing renders for anyone else. It is fixed, so it never moves the
 * page, and the page gets matching bottom padding so it never covers the last line of content.
 */
export default function PracticeBanner() {
  const { profile } = useAuth();
  const practice = isPracticeProfile(profile);
  useEffect(() => {
    if (!practice) return undefined;
    const prev = document.body.style.paddingBottom;
    document.body.style.paddingBottom = '40px';
    return () => {
      document.body.style.paddingBottom = prev;
    };
  }, [practice]);
  if (!practice) return null;
  return (
    <div
      role="status"
      data-testid="practice-banner"
      className="fixed inset-x-0 bottom-0 z-[150] bg-amber-100 px-4 py-2 text-center text-sm font-medium text-amber-950 shadow-[0_-1px_4px_rgba(0,0,0,0.15)] dark:bg-amber-900 dark:text-amber-50"
    >
      {PRACTICE_BANNER_TEXT}
    </div>
  );
}
